const LocalData = {
  setLoggedInfo: (info) => {
    localStorage.setItem("info", info);
  },
  getLoggedInfo: () => {
    return localStorage.getItem("info");
  },
  setSubscriptionInfo: (info) => {
    sessionStorage.setItem("info", info);
  },
  getSubscriptionInfo: () => {
    return sessionStorage.getItem("info");
  },
};

export default LocalData;
